import React from 'react';

// Material-UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

// Styles
import { useTheme } from '@mui/material/styles';
interface MemberEmailDialogProps {
  show: boolean;
  handleClose: () => void;
}

// #endregion

const MemberEmailHelpDialog: React.FC<MemberEmailDialogProps> = (props) => {

  // #region Styles

  const theme = useTheme();
  const styles = {
    divider: {
      margin: theme.spacing(2, 0, 2, 0),
    },
  }

  // #endregion

  return (
    <Dialog
      open={props.show}
      onClose={props.handleClose}
    >
      <DialogTitle>Member Email</DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>Emails can be sent to members in one or more member status categories.</Typography>
        <Typography component="div" variant="body1">
          <ul>
            <li>Select the appropriate member categories</li>
            <li>Select the "From" representing from whom the email will be sent</li>
            <li>Enter the subject and message content</li>
          </ul>
        </Typography>
        <Divider sx={styles.divider} />
        <Typography variant="body2">One or more PDF or .docx attachments can be included, max 10 MB each, and must be added individually.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.handleClose()} color="primary">Close</Button>
      </DialogActions>
    </Dialog>
  );

}

export default MemberEmailHelpDialog;